import {Pipe, PipeTransform} from '@angular/core';
import {ServiceJobDTOModel} from '../models/service-job-DTO.model';
import {CustomerModel} from '../models/customer.model';
import {SimpleEngineerBeanModel} from '../models/simple-engineer-bean.model';

@Pipe({
    name: 'filterJobs'
})
export class FilterJobsPipe implements PipeTransform {

    transform(jobs: ServiceJobDTOModel[], text: string, customerJobs: boolean, workshopJobs: boolean): ServiceJobDTOModel[] {
        if (text.length === 0) {
            return jobs;
        }
        text = text.toLowerCase();

        return jobs.filter(job => {
            if (!job.engineer) {
                job.engineer = new SimpleEngineerBeanModel();
                job.engineer.name = '';
            }
            if (!job.cust) {
                job.cust = new CustomerModel();
                job.cust.name = '';
            }
            if (!job.servicedItem.description) {
                job.servicedItem.description = '';
            }
            if (!job.servicedItem.pdesc) {
                job.servicedItem.pdesc = '';
            }
            const jobNumber = '' + job.jobNumber;
            return job.cust.name.toLowerCase().includes(text)
                || job.servicedItem.pdesc.toLowerCase().includes(text)
                || job.servicedItem.description.toLowerCase().includes(text)
                || job.jobType.toLowerCase().includes(text)
                || job.engineer.name.toLowerCase().includes(text)
                || jobNumber.includes(text);
        });
    }

}
